<template>
  <!-- v-show needs to be used here to ensure that <portal-target> is only rendered into the DOM once -->
  <v-footer
    v-show="hasContent"
    app
    inset
    outlined
    :elevation="4"
    padless
    color="footer"
    v-bind="$attrs"
    class="no-print px-2"
  >
    <portal-target
      name="footer"
      class="brewman-footer"
      data-qa="footer"
    ></portal-target>
  </v-footer>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";
import { Wormhole } from "portal-vue";

interface Events {
  (event: "content-updated", value: boolean): void;
}

const emit = defineEmits<Events>();

const hasContent = computed(() => {
  return Wormhole.hasContentFor("footer");
});

watch(
  hasContent,
  (value) => {
    emit("content-updated", value);
  },
  { immediate: true }
);
</script>

<style lang="sass" scoped>
.brewman-footer
  width: 100%
</style>
